import client from '@/api_client/client';
import { IWorkflow } from '@/types/workflows/IWorkflow';

export function list() {
	return client.get<{ workflows: Array<IWorkflow> }>('/workflows').then((res) => res.data);
}

export function get(args: { id: string }) {
	return client.get<IWorkflow>(`/workflows/${args.id}`).then((res) => res.data);
}

interface ICreateOrUpdateArgs {
	workflow: IWorkflow;
}

export function createOrUpdate(args: ICreateOrUpdateArgs) {
	return client.put(`/workflows/${args.workflow.id}`, args.workflow).then((res) => res.data);
}

export function remove(args: { id: string }) {
	return client.delete(`/workflows/${args.id}`).then((res) => res.data);
}

export default {
	createOrUpdate,
	get,
	list,
	remove,
};
